import makeHttpRequest from '../helpers/ajax';
import DateTimeHelper from '../helpers/date-time';
import PostInterstitial from './submitInterstitial';

const getAPIurl = () => {
    return WP_PREPRIME_API_URL;
};

const getAPIKey = () => {
    return WP_PREPRIME_API_KEY;
};

const getEsourceId = () => {
    const trackProperties = window.ltanalytics.getTrackProperties();
    return trackProperties ? trackProperties.esourceid : '';
};

const getPrePrimeDetails = (callBackFunction, callType, data) => {
    if (!data) {
        return 'Error: no data passed';
    }

    let url = getAPIurl();
    url += `partner?apikey=${getAPIKey()
    }&vertical=${data.vertical
    }&placement=${data.placement
    }&state=${data.state
    }${callType === 'debt-relief' ? `&amount=${data.amount}` : ''
    }${data && data.qFormId && data.qFormId !== null ? `&FormId=${data.qFormId}` : ''
    }&esourceid=${getEsourceId()}`;

    return makeHttpRequest({ url }).then((response) => {
        const json = JSON.parse(response);
        callBackFunction(json);
    }, () => {
        callBackFunction({});
        console.warn('There is some issue with network call, please try again');
    });
};

const getCSLeadTrackingId = (callBackFunction, data) => {
    if (!data) {
        return 'Error: no data passed';
    }

    let url = getAPIurl();
    url += `lead/getCSLeadTrackingId?apikey=${getAPIKey()
    }&formId=${data.formId}`;

    return makeHttpRequest({ url }).then((response) => {
        const json = JSON.parse(response);
        callBackFunction(json);
    }, () => {
        callBackFunction({});
        console.warn('There is some issue with network call, please try again');
    });
};

const getCookieValue = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return '';
};

const getURIComponentValue = (paramaName, url) => {
    const urlParam = !url ? window.location.href : url;

    const pattern = RegExp(`${paramaName.toLowerCase()}=.[^&]*`);
    const matched = urlParam.toLowerCase().match(pattern);
    if (matched) {
        return matched[0].split('=')[1];
    }
    return '';
};

const addTrackingParameters = (data) => {
    const cookieName = 'LT_MKT_TRACK';
    const myLtCookie = getCookieValue(cookieName);
    const parameters = {
        CChannel: 'cChannel',
        CMethod: 'cMethod',
        CSource: 'cSource',
        PPCKW: 'PPCKW',
        UtmCampaign: 'utm_campaign',
        UtmSource: 'utm_source',
        UtmMedium: 'utm_medium',
        CePage: 'ce_page',
        CsPage: 'cs_page',
        EsourceId: 'esourceid',
        Icode: 'icode',
        Cspage: 'cspage',
    };

    Object.keys(parameters).forEach((key) => {
        let paramValue = getURIComponentValue(parameters[key], window.location.href);
        if (!paramValue && myLtCookie) {
        // Read parameters from cookie
            paramValue = getURIComponentValue(parameters[key], myLtCookie);
        }
        data[key] = paramValue;
    });
};

const addFormDataAsParameters = (formData, leadData) => {
    const parameters = {
        State: 'state',
        StateName: 'stateName',
        City: 'city',
        ZipCode: 'zipCode',
        Amount: 'amount',
        FirstName: 'firstName',
        LastName: 'lastName',
        PhoneNumber: 'phoneNumber',
        EmailAddress: 'email',
        EmploymentStatus: 'employmentStatus',
        StreetAddress: 'streetAddress',
        SSN: 'ssn',
        Last4SSN: 'ssn4',
        DOB: 'dob',
        EstimatedCreditRating: 'estimatedCreditRating',
        UserAuthenticated: 'userAuthenticated',
        AnnualIncome: 'annualIncome',
        Password: 'password',
        Product: 'product',
        ProductType: 'productType',
        EmailOptIn: 'emailOptIn',
        ConsumerUId: 'consumerUId',
        Vertical: 'vertical',
        Placement: 'placement',
        Guid: 'guid',
        IsCurrentlyInsured: 'isCurrentlyInsured',
        InsuranceType: 'insuranceType',
    };

    Object.keys(parameters).forEach((key) => {
        const value = parameters[key];
        if (formData[value]) {
            leadData[key] = formData[value];
        }
    });
};

const getPropertyByName = (name) => {
    let properties = {};
    if (window.ltanalytics) {
        properties = window.ltanalytics.getTrackProperties();
    }
    return properties ? properties[name] || null : null;
};

const getMtaId = () => getPropertyByName('mtaid');

const getClickSessionId = () => {
    const clickSessionCookie = getCookieValue('ClickSessionId');
    return clickSessionCookie && clickSessionCookie !== '' ? clickSessionCookie : null;
};

const postPrePrimeLead = (data) => {
    if (!data) {
        return 'Error: no data passed';
    }
    const url = `${getAPIurl()}lead?apikey=${getAPIKey()}`;

    const leadData = {
        IsComplete: 'Y',
        WebpageName: window.location.href,
        DnsHostName: location.hostname,
        UserAgent: window.navigator.userAgent,
        PageUrl: window.location.href,
        FormStartDate: data.formStartDate || DateTimeHelper.getCurrentDate(),
        FormCompleteDate: DateTimeHelper.getCurrentDate(),
        Environment: WP_LT_ENV,
    };
    if (window.treeAuthId && window.treeAuthId !== '') {
        leadData.TreeAuthId = window.treeAuthId;
    }
    leadData.MtaId = getMtaId();
    leadData.ClickSessionId = getClickSessionId();
    addFormDataAsParameters(data, leadData);
    addTrackingParameters(leadData);
    return makeHttpRequest({ url, method: 'POST', params: leadData }).then(() => {
        console.warn('Success');
    }, () => {
        console.warn('Error while posting data to preprime');
    });
};
const postPrePrimeRefferal = (data, type) => {
    if (!data) {
        return 'Error: no data passed';
    }
    if (type === 'referral') {
        const postData = {
            partnername: data.partnername,
            partnerlogo: data.partnerlogo,
            partnerurl: data.partnerurl,
            lendingEntityId: data.lendingEntityId,
            qFormId: data.formId,
            sid: data.sid,
            variationName: data.variationName,
            placement: data.placement,
            destinationUrl: data.destinationUrl,
        };
        return PostInterstitial.submitInterstitialUrl(postData);
    }
    const url = `${getAPIurl()}lead/${type}?apikey=${getAPIKey()}`;
    return makeHttpRequest({ url, method: 'POST', params: data }).then(() => {
        console.warn('Data post to preprime was successful');
    }, () => {
        console.warn('Error while posting data to preprime');
    });
};

export {
    getPrePrimeDetails,
    getCSLeadTrackingId,
    postPrePrimeLead,
    postPrePrimeRefferal,
    getMtaId,
};
